import React from 'react';

import {DialogProps, Grid, Stack} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';
import {FlightPathMap, GoogleMapProvider} from '@wheeebo/polaris-ui';

import FlightPathProfileCard from './flightPath/FlightPathProfileCard';
import DialogBase from './DialogBase';
import {config} from '@components/Constants';

interface Props extends DialogProps {
  flightPathId: Types.UUID;
  onMissionSelected: (missionId: Types.UUID) => void;
  onClose: () => void;
}

const FlightPathDialog = ({flightPathId, onMissionSelected, onClose, ...props}: Props): JSX.Element => {
  return (
    <DialogBase title="Flight Path" onClose={onClose} {...props}>
      <GoogleMapProvider>
        <FlightPathMap apiKey={config.GOOGLE_MAP_API_KEY || ''} flightPathId={flightPathId} hideAllUIs />
      </GoogleMapProvider>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={5}>
          <Stack gap={1}>
            <FlightPathProfileCard flightPathId={flightPathId} onMissionSelected={onMissionSelected} />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={7}>
          <Stack gap={1}></Stack>
        </Grid>
      </Grid>
    </DialogBase>
  );
};

export default React.memo(FlightPathDialog);
